if (!customElements.get('site-selector')) {
	class SiteSelector extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('button');
			this.panel = this.querySelector('.f-disclosure-list');
            
            if (this.panel) this.panel.removeAttribute('hidden');

			this.button.addEventListener('click', this.toggleSelector.bind(this));
			this.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
            
            this.handleDropdownPos();
		}

		handleDropdownPos() {
			const offsetButton = this.button.getBoundingClientRect().right;
			if ((window.innerWidth - offsetButton) < 220) {
				this.button.nextElementSibling && this.button.nextElementSibling.classList.add('f-disclosure-list__right');
			}
		}

		hidePanel() {
			this.button.setAttribute('aria-expanded', 'false');
			this.removeAttribute('open');
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;
			this.hidePanel();
			this.button.focus();
		}

		toggleSelector() {
			this.button.focus();
			this.toggleAttribute('open');
			this.button.setAttribute('aria-expanded', (this.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget && !event.relatedTarget.classList.contains('f-disclosure-list__option');
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}
	customElements.define('site-selector', SiteSelector);
}

